import React from 'react';
import { useCurrentUserFamily } from '@/hooks/useCurrentUserFamily';
import { useFamilyMembers } from '@/hooks/useFamilyMembers';
import { useUser } from '@/contexts/UserContext';
import { PageLayout } from '@/components/layout';
import { Skeleton } from '@/components/ui/skeleton';
import { AlertCircle, Users } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import ActivityFeed from '@/components/activity/ActivityFeed';

const FamilyActivity = () => {
  const { user } = useUser();
  const { familyId, hasFamily, isLoading: familyLoading, error: familyError } = useCurrentUserFamily();
  const { familyMembers, isLoading: membersLoading } = useFamilyMembers(user?.id);

  if (familyLoading || membersLoading) {
    return (
      <PageLayout 
        title="Family Activity" 
        description="See what your family circle has been cooking and planning"
      >
        <div className="space-y-4 pb-14">
          {Array.from({ length: 3 }).map((_, i) => (
            <div key={i} className="p-4 border rounded-lg">
              <Skeleton className="h-4 w-48 mb-2" />
              <Skeleton className="h-4 w-32" />
            </div>
          ))}
        </div>
      </PageLayout>
    );
  }

  if (familyError || !hasFamily || !familyId) {
    return (
      <PageLayout 
        title="Family Activity" 
        description="See what your family circle has been cooking and planning"
      >
        <div className="pb-14">
        <Card>
          <CardContent className="pt-6">
            <div className="flex items-center gap-2 text-orange-600 mb-4">
              <AlertCircle className="h-5 w-5" />
              <p className="font-medium">No Family Circle Found</p>
            </div>
            <p className="text-gray-600 mb-4">
              You need to be part of a family circle to view family activities. 
              Create or join a family circle to start tracking your collaborative cooking journey.
            </p>
            <div className="flex items-center gap-2 text-blue-600">
              <Users className="h-4 w-4" />
              <span className="text-sm">Visit your Family Circle page to get started</span>
            </div>
          </CardContent>
        </Card>
        </div>
      </PageLayout>
    );
  }

  return (
    <PageLayout 
      title="Family Activity" 
      description="See what your family circle has been cooking and planning"
    >
      <div className="pb-14">
      {familyMembers && (
        <ActivityFeed 
          familyId={familyId} 
          familyMembers={familyMembers}
        />
      )}
      </div>
    </PageLayout>
  );
};

export default FamilyActivity;